import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {formatCurrency} from '../utils/currency';
import StatusLabel from './StatusLabel';
import Loading from './Loading';

class PreviouslyPurchasedItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      perPage: 5,
    };
  }

  componentDidMount() {
    if (window.initCarousels) {
      setTimeout(window.initCarousels, 0);
    }
  }

  render() {
    if (this.props.isFetching) {
      return (<Loading/>);
    }

    const items = this.props.items;

    if (window.initCarousels) {
      setTimeout(window.initCarousels, 100);
    }

    return items.length ?
      (
        <div className="previous-items">
          <h4>Buy it again</h4>

          <div className="previous-items__list" data-per-page={this.state.perPage}>
            {items.map(product =>
              <div key={product.id} className="previous-items__item row">
                <div className="small-5 columns">
                  <a className="previous-items__item__image" href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>
                    <img src={`${ROOT_URL}/uploads/products/${product.image}`} />
                  </a>
                </div>
                <div className="small-7 columns">
                  <div className="previous-items__item__body">
                    <p className="previous-items__item__title">
                      <a href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>{product.name}</a>
                    </p>
                    <p className="previous-items__item__status">
                      <StatusLabel remainingStock={product.remainingStock}
                                   isDiscontinued={product.isDiscontinued}
                                   isComingSoon={product.isComingSoon}
                                   callForPricing={product.callForPricing}
                                   specialShipDate={product.specialShipDate}
                                   specialShipDays={product.specialShipDays}
                                   backorderShipDate={product.backorderShipDate}
                                   backorderShipDays={product.backorderShipDays}/>
                    </p>
                    {
                      !product.callForPricing && 
                      <div>
                        <span className="previous-items__item__price">{formatCurrency(product.salePrice || product.price)}</span>
                        {
                          product.remainingStock > 0 && !product.isDiscontinued && !product.isComingSoon && !product.callForPricing &&
                          <a onClick={e => this.props.onAddToCart(product)} className="previous-items__item__button button tiny primary">Add to cart</a>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            )}
          </div>
          <Loading/>

        </div>
      )

      : null;
  }
}

PreviouslyPurchasedItems.propTypes = {
  items: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onAddToCart: PropTypes.func.isRequired
};

export default PreviouslyPurchasedItems;
